module.exports = __webpack_public_path__ + "img/s7Dragons_350x350.60d6d8c3.jpg";